<div class="empathy-preview__container">
  @if (showDeviceToolbar$()) {
    <mat-toolbar class="survey-viewer__toolbar-devices">
      <div class="survey-viewer__devices">
        <button
          mat-stroked-button
          data-testid="survey-preview-desktop-device-button"
          [class.active]="activeDevice$() === previewDevice.Desktop"
          (click)="activeDevice$.set(previewDevice.Desktop)"
        >
          <fa-icon [icon]="faDesktop"></fa-icon>
          <span>Desktop</span>
        </button>
        <button
          mat-stroked-button
          data-testid="survey-preview-phone-device-button"
          [class.active]="activeDevice$() === previewDevice.Phone"
          (click)="activeDevice$.set(previewDevice.Phone)"
        >
          <fa-icon [icon]="faMobile"></fa-icon>
          <span>Phone</span>
        </button>
        <button
          mat-stroked-button
          data-testid="survey-preview-tablet-device-button"
          [class.active]="activeDevice$() === previewDevice.Tablet"
          (click)="activeDevice$.set(previewDevice.Tablet)"
        >
          <fa-icon [icon]="faTablet"></fa-icon>
          <span>Tablet</span>
        </button>
      </div>
    </mat-toolbar>
  }

  <empathy-device-wrapper [ngClass]="displayedDevice$()" [activeDevice]="displayedDevice$()">
    @if (hostConfig$(); as hostConfig) {
      <empathy-preview-viewer-host
        [authoredSurveyJson]="hostConfig.authoredSurveyJson"
        [generation]="hostConfig.generation"
        [languageCode]="hostConfig.languageCode"
        [replacesPreviewSessionId]="hostConfig.replacesPreviewSessionId"
        [variables]="hostConfig.variables"
        (busyChange)="onHostBusyChange($event)"
        (restartRequested)="onRestartRequested()"
        (sessionCreated)="onSessionCreated($event)"
      />
    }
  </empathy-device-wrapper>
</div>
